import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const Container = styled(Box)`
  width: 100%;
  border-radius: 20px;
`;

export const Badge = styled(Box)`
  width: 100%;
  border-radius: 20px 20px 0 0;
  ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
`;

export const InfoBlock = styled(Box)`
  display: flex;
  gap: 5px;
  margin-bottom: 12px;
  align-items: baseline;

  img {
    width: 16px;
  }
`;

export const Details = styled(Box)`
  width: 100%;
  border-radius: 0 0 20px 20px;

  ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
  ${({ $paddingTop }) => Boolean($paddingTop) && `padding-top: ${$paddingTop}px;`};
  ${({ $paddingX }) => Boolean($paddingX) && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};

  ${({ $paddingBottom }) => Boolean($paddingBottom) && `padding-bottom: ${$paddingBottom}px;`};
  ${({ $mb }) => Boolean($mb) && `margin-bottom: ${$mb}px;`};
`;
